import {ReactNode} from 'react';

export type NodeTransform = (node: ReactNode, previousToken?: string) => ReactNode;

export function combineMarkdownNodeTransforms(...transforms: ReadonlyArray<NodeTransform>): NodeTransform {
  return (node, previousToken) => {
    let transformedNode = node;

    for (const transform of transforms) {
      const result = transform(transformedNode, previousToken);
      transformedNode = result;
    }

    return transformedNode;
  };
}

export enum ListTypesEnum {
  ORDERED = 'ORDERED',
  UNORDERED = 'UNORDERED',
}
